import React, { Suspense } from 'react';
import { FullWidthSpinner } from '../loader-components';

import { useSimpleQuery } from '../../hooks';

import { RESTUtils } from './utils';

const LazyOperationsApp = React.lazy(() => import('./OperationsApp'));

/*
Capabilities:
- CAP-OUTLET-REDEMPTION-CODE
- CAP-OUTLET-STOCK-CONTROL

Responsibilities:
- Bootstrap the outlet operations app from query parameters and load the
  outlet-scoped data required by stock control and daily-code views.

Context:
- project-intelligence/capabilities/requested/outlet/daily-redemption-code.md
- project-intelligence/capabilities/requested/outlet/stock-control.md
*/

function LazyOperationsAppWithAuthenticator() {
    const query = useSimpleQuery();
    const keyFromQueryParams = query.key || '';
    const locationFromQueryParams = query.location || '';
    const orgFromQueryParams = query.org || '';
    console.log(`From Query:\nkey = ${keyFromQueryParams}\norg=${orgFromQueryParams}\nlocation = ${locationFromQueryParams}`)
    
    const [locationData, setLocationData] = React.useState(null);

    const refreshLocationData = React.useCallback(() => {
        return RESTUtils.call(`/get-stock-control-info/${orgFromQueryParams}/${locationFromQueryParams}/${keyFromQueryParams}`, {}, {method: 'GET'})
            .then(({ data }) => {
                setLocationData(data);
            })
    }, [orgFromQueryParams, locationFromQueryParams, keyFromQueryParams]);

    React.useEffect(() => { refreshLocationData() }, [refreshLocationData])

    return (
        <Suspense fallback={<FullWidthSpinner text='Loading...' scale={3}/>}>
            {
                (!!locationData) ? (
                    <LazyOperationsApp
                        org={orgFromQueryParams} location={locationFromQueryParams} apiKey={keyFromQueryParams}
                        locationData={locationData}
                        refreshLocationData={refreshLocationData}
                    />
                ) : (
                    <FullWidthSpinner text='Loading...' scale={3}/>
                )
            }
        </Suspense>
    );
}

export default LazyOperationsAppWithAuthenticator;
